module.exports = require("lru-cache");